import { Box, ButtonBase } from "@mui/material";
import React from "react";
import { ORDER_TYPES_VALUES } from "../../constants/enums";
import Iconify from "../iconify/Iconify";
import "./OrderTypeSelector.css";

function OrderTypeSelector({ type, selectedOrderType, onOrderTypeSelected }) {
  return (
    <>
      <Box
        className={`menu-item-pick-type ${
          type === "header" && "menu-item-pick-type-header"
        }`}
      >
        {ORDER_TYPES_VALUES.map((order) => {
          const isActive = selectedOrderType.type === order.value;
          return (
            <Box key={order.value} sx={{ position: "relative", width: "100%" }}>
              <ButtonBase
                onClick={() => onOrderTypeSelected({ type: order.value })}
                className={`menu-item-pick-type-btn ${
                  isActive ? "active" : ""
                }`}
                component="div"
                style={{
                  width: "100%",
                  fontSize: isActive ? 15 : 12,
                  fontWeight: isActive ? 600 : 500,
                  transition: "all 0.2s ease",
                }}
              >
                <Iconify icon={order.icon} width={isActive ? 20 : 18} />
                <Box>{order.label}</Box>
                {isActive && <Iconify icon="material-symbols:check-circle" />}
              </ButtonBase>
            </Box>
          );
        })}
      </Box>
    </>
  );
}

export default OrderTypeSelector;
